import React from 'react';
import Icon from '../../common/Icons';
import { getHeadDoctorHubIcon } from '../headDoctorHubIcons';

export default function HeadDoctorHubCard({ def, badgeLabel, onClick, onPrescriptionLink }) {
  const iconName = getHeadDoctorHubIcon(def);
  const isReady = def.badge === 'ready';

  return (
    <article
      className={`hd-hub-card ${isReady ? 'hd-hub-card--ready' : 'hd-hub-card--soon'}`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(ev) => {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          onClick();
        }
      }}
    >
      <div className="hd-hub-card__icon-wrap" aria-hidden>
        <Icon name={iconName} size={22} />
      </div>
      <div className="hd-hub-card__body">
        <div className="hd-hub-card__top">
          <h3 className="hd-hub-card__title mb-0">{def.title}</h3>
          <span className={`hd-hub-badge ${isReady ? 'hd-hub-badge--ready' : 'hd-hub-badge--soon'}`}>
            {badgeLabel}
          </span>
        </div>
        <p className="hd-hub-card__desc mb-0">{def.subtitle}</p>
        {def.kind === 'route' && def.routeKey === 'PRESCRIPTIONS' && onPrescriptionLink && (
          <button
            type="button"
            className="hd-hub-card__link btn btn-link btn-sm p-0 mt-2"
            onClick={(e) => {
              e.stopPropagation();
              onPrescriptionLink();
            }}
          >
            Rédiger une ordonnance
          </button>
        )}
      </div>
      <span className="hd-hub-card__chevron" aria-hidden>
        →
      </span>
    </article>
  );
}
